import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoryScroll from "./components/CategoryScroll";
import ArticleMatrix from "./components/ArticleMatrix";
import CTASection from "./components/CTASection";
import TrendingGrid from "./components/TrendingGrid";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Best Pandabuy Spreadsheet Database 2026",
  "url": "https://pandabuy.run/",
  "description": "Discover the most complete Pandabuy Spreadsheet database with daily updated product finds, price comparisons, and curated lists for sneakers, streetwear, accessories, and luxury items.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://pandabuy.run/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryScroll />
        <ArticleMatrix />
        <CTASection />
        <TrendingGrid />
      </main>
      <Footer />
    </>
  );
}